import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useLoading } from '../../../providers/LoadingProvider';

const StyledLoadingWrap = styled.div<LoadingScreenIconProps>`
  position: ${(props) => props.position};
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: ${(props) => props.theme.loading[props.colorPattern].bgd};
  z-index: ${(props) => props.theme.zIndex.loading};
`;

const load = keyframes`
   0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }
  40% {
    box-shadow: 0 2.5em 0 0;
  }
`;

const StyledLoadingIcon = styled.div<LoadingScreenIconProps>`
  &,
  &::before,
  &::after {
    border-radius: 50%;
    width: 2.5em;
    height: 2.5em;
    animation-fill-mode: both;
    animation: ${load} 1.8s infinite ease-in-out;
  }

  & {
    color: ${(props) => props.theme.loading[props.colorPattern].iconColor};
    font-size: 10px;
    text-indent: -9999em;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -50px;
    margin-left: -12px;
    transform: translateZ(0);
    animation-delay: -0.16s;
  }

  &:before,
  &:after {
    content: '';
    position: absolute;
    top: 0;
  }

  &:before {
    left: -3.5em;
    animation-delay: -0.32s;
  }

  &:after {
    left: 3.5em;
  }
`;

type LoadingScreenIconProps = {
  // CSSのposition。デフォルトがfixed
  position: string;
  colorPattern: 'black' | 'white';
};

export const LoadingScreenIcon: React.FC<Partial<LoadingScreenIconProps>> = ({
  position = 'fixed',
  colorPattern = 'black'
}) => {
  return (
    <StyledLoadingWrap position={position} colorPattern={colorPattern}>
      <StyledLoadingIcon position={position} colorPattern={colorPattern} />
    </StyledLoadingWrap>
  );
};

export const Loading: React.FC<{}> = () => {
  const { loading } = useLoading();

  return <>{loading && <LoadingScreenIcon />}</>;
};
